import { useState } from "react";
import "./App.css";
import { CrimsonServiceDeskHeader } from "./component/CrimsonServiceDeskHeader";
import { SearchBar } from "./component/search/SearchBar";
import { SearchResultTable } from "./component/tables/person/SearchResultTable";
import { Office365GroupsSearchResultsTable } from "./component/tables/office365_group/Office365GroupsSearchResultsTable";
import { AlternateAliasSearchResultsTable } from "./component/tables/alias/AlternateAliasSearchResultTable";
import { ManagedAccountsSearchResultTable } from "./component/tables/managed_accounts/ManagedAccountsSearchResultTable";

import { UserModuleContext } from "./component/context/UserModuleContext";
import { Office365GroupContext } from "./component/context/Office365GroupContext";
import { AlternateAliasContext } from "./component/context/AlternateAliasContext";
import { ManagedAccountContext } from "./component/context/ManagedAccountContext";

import { UserContainer } from "./component/tables/person/UserContainer";
import { Office365GroupsContainer } from "./component/tables/office365_group/Office365GroupsContainer";
import { AlternateAliasContainer } from "./component/tables/alias/AlternateAliasContainer";
import { ManagedAccountContainer } from "./component/tables/managed_accounts/ManagedAccountContainer";

import { BottomNavigation, BottomNavigationAction, Box, Typography, Divider } from "@mui/material";
import { Feedback, LibraryBooks } from "@mui/icons-material";

const WSU_RED = "#A60F2D";

const SectionHeader = ({ title }) => (
    <Box sx={{ mt: 4, mb: 1, px: 1 }}>
      <Typography
          variant="overline"
          sx={{ color: WSU_RED, fontWeight: 700, letterSpacing: 1.5, fontSize: "0.75rem" }}
      >
        {title}
      </Typography>
      <Divider sx={{ mt: 0.5, borderColor: "#e0e0e0" }} />
    </Box>
);

export const Home = () => {
  const [text, setText] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [searchId, setSearchId] = useState(0);
  const [linkVal] = useState('');

  const [userModule, setUserModule] = useState({
    isOpen: false,
    userId: null,
    wsuId: null,
    isRestricted: false,
    isLoaded: false,
    userData: null,
    ADData: null,
  });

  const [groupModule, setGroupModule] = useState({
    refresh: false,
    isOpen: false,
    displayName: null,
    data: null,
    owners: null,
    members: null,
    id: null,
    searchResults: null,
    mode: "read",
    visibility: null,
  });

  const [aliasModule, setAliasModule] = useState({
    isOpen: false,
    displayName: null,
    upn: null,
    dn: null,
    data: null,
    searchResults: null,
  });

  const [managedAccountModule, setManagedAccountModule] = useState({
    isOpen: false,
    displayName: null,
    mode: "read",
    upn: null,
    dn: null,
    data: null,
    searchResults: null,
  });

  const handleClick = () => {
    setSearchId((prev) => prev + 1);
    setShowResults(true);
  };

  const handleChange = (event, newValue) => {
    window.location.replace(newValue);
  };

  const renderSearchResults = () => (
      <Box sx={{ width: "80%", mx: "auto", mt: 2 }}>
        <SectionHeader title="Okta Users" />
        <SearchResultTable key={`search-result-${text}-${searchId}`} text={text.trim()} />

        <SectionHeader title="Office 365 Groups" />
        <Office365GroupsSearchResultsTable key={`office-365-result-${text}-${searchId}`} text={text.trim()} />

        <SectionHeader title="Alternate Aliases" />
        <AlternateAliasSearchResultsTable key={`alternate-alias-search-${text}-${searchId}`} text={text.trim()} />

        <SectionHeader title="Managed Accounts" />
        <ManagedAccountsSearchResultTable key={`managed-accounts-search-${text}-${searchId}`} text={text.trim()} />
      </Box>
  );

  return (
      <div className="App">
        <UserModuleContext.Provider value={{ userModule, setUserModule }}>
          <Office365GroupContext.Provider value={{ groupModule, setGroupModule }}>
            <AlternateAliasContext.Provider value={{ aliasModule, setAliasModule }}>
              <ManagedAccountContext.Provider value={{ managedAccountModule, setManagedAccountModule }}>
                <CrimsonServiceDeskHeader />
                <UserContainer />
                <Office365GroupsContainer />
                <AlternateAliasContainer />
                <ManagedAccountContainer />

                <Box sx={{ pt: 8 }}>
                  <Box sx={{ width: "80%", mx: "auto", mt: 4 }}>
                    <SearchBar
                        text={text}
                        onTextChange={setText}
                        handleClick={handleClick}
                        placeholderValues="NID/FID/WSUID"
                    />
                  </Box>

                  {showResults && renderSearchResults()}
                </Box>

                <BottomNavigation
                    className="csd-link-container"
                    value={linkVal}
                    onChange={handleChange}
                    showLabels
                >
                  <BottomNavigationAction
                      label="Crimson Service Desk Portal"
                      value="https://jira.esg.wsu.edu/servicedesk/customer/portal/34"
                      icon={<Feedback />}
                  />
                  <BottomNavigationAction
                      label="Tech Tools User Guide"
                      value="https://confluence.esg.wsu.edu/display/KB/Tech+Tools+Users+Guide"
                      icon={<LibraryBooks />}
                  />
                </BottomNavigation>
              </ManagedAccountContext.Provider>
            </AlternateAliasContext.Provider>
          </Office365GroupContext.Provider>
        </UserModuleContext.Provider>
      </div>
  );
};